import React from 'react';
import Icon from './Icon';
import './ui.css';

const VARIANT_CLASS = {
  primary: 'pn-btn--primary',
  secondary: 'pn-btn--secondary',
  danger: 'pn-btn--danger',
  ghost: 'pn-btn--ghost',
};

const Button = ({
  children,
  variant = 'primary',
  type = 'button',
  disabled = false,
  loading = false,
  icon,
  iconPosition = 'left',
  block = false,
  size,
  className = '',
  onClick,
  ...rest
}) => {
  const classes = [
    'pn-btn',
    VARIANT_CLASS[variant] || VARIANT_CLASS.primary,
    block ? 'pn-btn--block' : '',
    size === 'sm' ? 'pn-btn--sm' : '',
    variant === 'icon' ? 'pn-btn--icon' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const iconEl = icon ? <Icon name={icon} size={size === 'sm' ? 16 : 20} color="currentColor" /> : null;

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      onClick={onClick}
      {...rest}
    >
      {loading ? (
        <span className="pn-btn__spinner" aria-hidden="true" />
      ) : (
        <>
          {icon && iconPosition === 'left' ? iconEl : null}
          {children}
          {icon && iconPosition === 'right' ? iconEl : null}
        </>
      )}
    </button>
  );
};

export default Button;
